<template>

<v-content>
<v-container class="my-12">
  <div class="loading" v-if="loading">
    <div class="loader"></div>
</div>
    <v-row class="mb-4">
            <v-col

        cols="12"
        sm="12"
      >
            <v-card class="pa-4" elevation="6">
           <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                        Data Formats
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>
          <v-card-text>
          <p class="secondary--text font-weight-medium ma-0"  >OpenNLP Format:</p>
        
          <code>{{OpenNLPcode1}}</code>
          <br>
          <code>{{OpenNLPcode2}}</code>
          <br>
          <div class="pt-4"></div>
          <p class="secondary--text font-weight-medium ma-0"  >spaCy Format:</p>
          <code>{{spaCycode1}}</code>
          <br>
          <code>{{spaCycode2}}</code>
          <p class=" py-4 secondary--text font-weight-medium ma-0"  >BIO Format:</p>
          <v-row>
          <v-col>
            <v-row>
             
             <v-col>
            <code>
B-Pessoa	Charles<br>
I-Pessoa	Lindsey<br>
 O	envia<br>
 O	carta<br>
 O	a<br>
B-Pessoa	Wijngaarden<br>
O	pedindo<br>
O	uma<br>
</code>
  </v-col>
  <v-col>
      <code>

O	cópia<br>
O	das<br>
O	emendas<br>
O	de<br>
B-Pessoa	Koster</code>
  </v-col>
  </v-row>
</v-col>
<v-col>

    <v-row>   
             <v-col>
                 <code>
O	Filiação<br>
O	:<br>
B-Pessoa	Inacio<br>
I-Pessoa	Vaz<br>
I-Pessoa	Dantas<br>
O	e<br>
B-Pessoa	Vitoria<br>
I-Pessoa	Alvares<br>
                 </code>
             </v-col>
             <v-col>
                 <code>
I-Pessoa	Lima<br>
O	.<br>
O	Natural<br>
O	e/ou<br>
O	residente<br>
O	em<br>
B-Local	VIANA<br>
I-Local	CASTELO-MONSERRATE<br>
                 </code>
             </v-col>
    </v-row>
          </v-col>
          </v-row>
                      <p class=" py-4 secondary--text font-weight-medium ma-0"  >CSV Format:</p>
           <v-row>
          <v-col>

            <v-row>
             
             <v-col>
            <code>
Sentence #,Word,Tag<br>
,Zemanek,I-Pessoa<br>
,envia,O<br>
,carta,O<br>
,a,O<br>
,J,B-Pessoa<br>
,Carter,I-Pessoa<br>
,concordando,O<br>
,com,O<br>
</code>
  </v-col>
  <v-col>
      <code>
,o,O<br>
,pagamento,O<br>
,ao,O<br>
,Dr,O<br>
,Turski,B-Pessoa<br></code>
  </v-col>
  </v-row>
</v-col>
<v-col>

    <v-row>   
             <v-col>
                 <code>
Sentence: 2275,Registo,O<br>
,de,O<br>
,batismo,O<br>
,n,O<br>
,º,O<br>
,2,O<br>
,Manuel,B-Pessoa<br>
,Pai,O<br>
,Manuel,B-Pessoa<br>

                 </code>
             </v-col>
             <v-col>
                 <code>
,de,I-Pessoa<br>
,Félix,I-Pessoa<br>
,de,I-Pessoa<br>
,Sousa,I-Pessoa<br>
,Mãe,O<br>
,Francisca,B-Pessoa<br>
,Pereira,I-Pessoa<br>
,da,I-Pessoa<br>
,Silva,I-Pessoa
                 </code>
             </v-col>
    </v-row>
          </v-col>
          </v-row>
          
          </v-card-text>
        </v-card>

            </v-col>
    </v-row>
    <v-row class="mb-4">
            <v-col

        cols="12"
        sm="12"
      >

        <v-card class="pa-4" elevation="6">
           <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                        Data Parsers
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>



 <v-row >
            <v-col
              cols="12"
              md="4"
            >
            <v-spacer ></v-spacer>
              <v-card
                class="py-6 px-4 ma-3"
                color="grey lighten-5"
                elevation="3"
                flat
              >

              <v-card-title >
                <div class="text-center" style="width:100%">
                <p class=" text-center secondary--text font-weight-medium ma-0"  >OpenNLP             <v-icon
                        large
                        color="#AD8744"
                        
                      >mdi-arrow-right-bold</v-icon> spaCy</p>
                </div>
              </v-card-title>
                <v-card-text
                 >
                                Convert file from OpenNLP into spaCy format.

                </v-card-text>
                <v-spacer ></v-spacer>
           <div class="pt-2" >
          <v-file-input show-size v-model="file1" label="Select a file to Process."></v-file-input>
             <v-col class="text-right ma-0 pa-0">
                       <v-btn
            color="grey"
            outlined
            align="bottom"
            large
            @click="postFile1"
          >
            <span class="grey--text text--darken-1 font-weight-bold">
              Convert
            </span>
            <v-icon
                        
                        color="#AD8744"
                        
                      >mdi-cog-refresh</v-icon>
          </v-btn>
             </v-col>

          </div>
              </v-card>
            </v-col>


                        <v-col
              cols="12"
              md="4"
            >
            <v-spacer ></v-spacer>
              <v-card
                class="py-6 px-4 ma-3"
                color="grey lighten-5"
                elevation="3"
                flat
              >

              <v-card-title >
                <div class="text-center" style="width:100%">
                <p class=" text-center secondary--text font-weight-medium ma-0"  >
                  spaCy    
                           <v-icon
                        large
                        color="#AD8744"
                        
                      >mdi-arrow-right-bold</v-icon> BIO</p>
                </div>
              </v-card-title>
                <v-card-text
                 >
                                Convert file from spaCy into BIO format. 
                                The input must be a .py file with an array called TRAIN_DATA.

                </v-card-text>
                <v-spacer ></v-spacer>
           <div class="pt-2" >
          <v-file-input show-size v-model="file2" label="Select a file to Process."></v-file-input>
             <v-col class="text-right ma-0 pa-0">
                       <v-btn
            color="grey"
            outlined
            align="bottom"
            large
            @click="postFile2"
          >
            <span class="grey--text text--darken-1 font-weight-bold">
              Convert
            </span>
            <v-icon
                        
                        color="#AD8744"
                        
                      >mdi-cog-refresh</v-icon>
          </v-btn>
             </v-col>

          </div>
              </v-card>
            </v-col>
                        <v-col
              cols="12"
              md="4"
            >
            <v-spacer ></v-spacer>
              <v-card
                class="py-6 px-4 ma-3"
                color="grey lighten-5"
                elevation="3"
                flat
              >

              <v-card-title >
                <div class="text-center" style="width:100%">
                <p class=" text-center secondary--text font-weight-medium ma-0"  >
                  BIO            
                   <v-icon
                        large
                        color="#AD8744"
                        
                      >mdi-arrow-right-bold</v-icon> 
                      CSV</p>
                </div>
              </v-card-title>
                <v-card-text
                 >
                                Convert file from BIO into CSV format.

                </v-card-text>
                <v-spacer ></v-spacer>
           <div class="pt-2" >
          <v-file-input show-size v-model="file3" label="Select a file to Process."></v-file-input>
             <v-col class="text-right ma-0 pa-0">
                       <v-btn
            color="grey"
            outlined
            align="bottom"
            large
            @click="postFile3"
          >
            <span class="grey--text text--darken-1 font-weight-bold">
              Convert
            </span>
            <v-icon
                        
                        color="#AD8744"
                        
                      >mdi-cog-refresh</v-icon>
          </v-btn>
             </v-col>

          </div>
              </v-card>
            </v-col>
          </v-row>

        </v-card>

      </v-col>

    </v-row>
    </v-container>

    </v-content>


</template>

<script>
// @ is an alias to /src
import axios from 'axios'
const dataAPI = require("@/config/hosts").dataAPI;

export default {
  name: 'Home',
 data() {
    return {
    file1: [],
    file2: [],
    file3: [],
    loading:false,
    OpenNLPcode2:'Registo de batismo n.º 7: <START:Pessoa> Palmira <END> . Pai: <START:Pessoa> Manuel Francisco Gomes Júnior <END> ; Mãe: <START:Pessoa> Ana de Jesus <END>',
    OpenNLPcode1: '<START:Pessoa> Fraser Duncan <END> envia carta a <START:Pessoa> Willem van der Poel <END> , cancelando sua presença na reunião de <START:Local> Varsóvia <END> .',
    spaCycode1:`TRAIN_DATA = [("Willem van der Poel envia carta a H. Gumin sobre o ISO TC97.", {"entities":[(0, 19, "Pessoa"),(34, 42, "Pessoa")]}),`,
   spaCycode2:`("Registo de casamento João Francisco Rodrigues c.c. Isabel de Jesus da Encarnação", {"entities":[(21, 45, "Pessoa"),(51, 80, "Pessoa")]})]`,
    }
  },
  methods:{    
    postFile1: function(){
        if  (this.file1 == "") { alert("Please select a file!"); return false;}
        let formData = new FormData();
          formData.append("ficheiro", this.file1)
          this.loading=true
        axios.post(dataAPI+'parsers/opennlp/spacy',
          formData,
          {"timeout": 9000000},
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then((dados) => { 
          this.loading=false
            const url = window.URL.createObjectURL(new Blob([dados.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'converted');
  document.body.appendChild(link);
  link.click();

        })
        .catch((error)=>{this.loading=false; alert("Some error occurred! Please check your file.")})
      },
          postFile3: function(){
        if  (this.file3 == "") { alert("Please select a file!"); return false;}
        let formData = new FormData();
          formData.append("ficheiro", this.file3)
          this.loading=true
        axios.post(dataAPI+'parsers/bio/csv',
          formData,
          {"timeout": 9000000},
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then((dados) => { 
                    this.loading=false
            const url = window.URL.createObjectURL(new Blob([dados.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'converted');
  document.body.appendChild(link);
  link.click();

        })
        .catch((error)=>{this.loading=false; alert("Some error occurred! Please check your file.")})
      },
          postFile2: function(){
        if  (this.file2 == "") { alert("Please select a file!"); return false;}
        let formData = new FormData();
          formData.append("ficheiro", this.file2)
          this.loading=true
        axios.post(dataAPI+'parsers/spacy/bio',
          formData,
          {"timeout": 9000000},
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then((dados) => { 
                    this.loading=false
            const url = window.URL.createObjectURL(new Blob([dados.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'converted');
  document.body.appendChild(link);
  link.click();

        })
        .catch((error)=>{this.loading=false; alert("Some error occurred! Please check your file.")})
      },
    
  }
};
</script>



<style scoped>
.loading {
    position: fixed;
    top: 0; right: 0;
    bottom: 0; left: 0;

    filter: alpha(opacity=40);
    z-index:1000000;

     background-color:rgb(236, 234, 234,0.4);
    z-index:100;

}
.loader {
    left: 50%;
    margin-left: -4em;
    font-size: 10px;
    border: .8em solid rgba(218, 219, 223, 1);
    border-left: .8em solid #AD8744;
    animation: spin 1.1s infinite linear;
    z-index:10000;
    opacity: 1;
}
.loader, .loader:after {
    border-radius: 50%;
    width: 8em;
    height: 8em;
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -4.05em;
    z-index:10000;
    opacity: 1;
}

@keyframes spin {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

</style>

